<template>
    <div v-if="legend.rows" class="legend">
        <ol>
            <li v-for="row in legend.rows">
                <span class="colour" :style="{ backgroundColor: retrieveColour(row) }"></span>
                {{ row.value}}
            </li>
        </ol>
    </div>
</template>

<script>
    import Widget from './Widget.vue';

    export default {
        extends: Widget,
        props: {
            legend: Object
        }
    }
</script>
